import { render, staticRenderFns } from "./pay-channel.vue?vue&type=template&id=0c6773aa&scoped=true&"
import script from "./pay-channel.vue?vue&type=script&lang=js&"
export * from "./pay-channel.vue?vue&type=script&lang=js&"
import style0 from "./pay-channel.vue?vue&type=style&index=0&id=0c6773aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6773aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6773aa')) {
      api.createRecord('0c6773aa', component.options)
    } else {
      api.reload('0c6773aa', component.options)
    }
    module.hot.accept("./pay-channel.vue?vue&type=template&id=0c6773aa&scoped=true&", function () {
      api.rerender('0c6773aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sms-channel-management/pay-channel.vue"
export default component.exports